import type { MouseEvent, JSX } from "react";
import { Button, Spinner } from "@fluentui/react-components";

export interface FluentButtonProps {
  id?: string;
  text: string;
  icon?: JSX.Element;
  appearance?: "primary" | "secondary" | "outline" | "subtle" | "transparent";
  type?: "button" | "submit";
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export function FluentButton({
  id,
  text,
  icon,
  appearance = "primary",
  type = "button",
  loading = false,
  disabled = false,
  className,
  onClick,
}: FluentButtonProps): JSX.Element {
  return (
    <Button
      id={id}
      type={type}
      appearance={appearance}
      disabled={disabled || loading}
      className={className}
      icon={loading ? <Spinner size="tiny" /> : icon}
      onClick={onClick}
    >
      {text}
    </Button>
  );
}
